var render, staticRenderFns
import script from "./ConfirmOrderPop.vue?vue&type=script&lang=js"
export * from "./ConfirmOrderPop.vue?vue&type=script&lang=js"
import style0 from "./ConfirmOrderPop.vue?vue&type=style&index=0&id=5c05411c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c05411c",
  null
  
)

export default component.exports